import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import Message from "../message";

function SheetsCombiner() {
  const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`;

  const [sheetFile, set_sheetFile] = useState("");
  const [status_sheetFile, setStatus_sheetFile] = useState("");
  const [company_website, setCompany_website] = useState(false);

  const submit_sheetFile = async () => {
    setStatus_sheetFile("");

    if (sheetFile.length <= 0) {
      setStatus_sheetFile("Upload Delivery Excel File!");
    } else {
      setStatus_sheetFile("Processing Files...");

      const formDatasheetFile = new FormData();
      formDatasheetFile.append("file", sheetFile);
      formDatasheetFile.append("get_company_website", company_website);

      const requestOptions = {
        method: "POST",
        body: formDatasheetFile,
      };

      console.log(formDatasheetFile);

      try {
        const sheetFile_response = await fetch(
          apiServer + `api/sheets_combiner/upload_file/`,
          requestOptions
        );
        const sheetFile_status_id = await sheetFile_response.json();
        const sheetFile_status = sheetFile_status_id.detail
          ? sheetFile_status_id.detail
          : sheetFile_status_id;
        setStatus_sheetFile(sheetFile_status);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Form.Control
        type="file"
        name="verifier"
        id="verifier"
        className="verifierxcls"
        onChange={(e) => set_sheetFile(e.target.files[0])}
      />
      <Form.Check
        onChange={(e) => setCompany_website(e.target.checked)}
        type="checkbox"
        style={{ marginTop: "5px", marginLeft: "2px"}}
        label="Get Company Websites"
      />
      <Button
          style={{
            marginTop: "1.25rem",
            marginRight: "1rem",
            backgroundColor: "#3a4c7a",
            border: "none",
          }}
          href="./templates/sheet_combiner.xlsx"
          download
        >
          Download Template
        </Button>
      <Button
        variant="primary"
        type="button"
        style={{ marginTop: "15px" }}
        onClick={() => submit_sheetFile()}
      >
        Submit
      </Button>
      {Message(status_sheetFile, setStatus_sheetFile)}
    </div>
  );
}
export default SheetsCombiner;